import { render, staticRenderFns } from "./WidgetPageList.vue?vue&type=template&id=063d3acb&scoped=true&"
import script from "./WidgetPageList.vue?vue&type=script&lang=js&"
export * from "./WidgetPageList.vue?vue&type=script&lang=js&"
import style0 from "./WidgetPageList.vue?vue&type=style&index=0&id=063d3acb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d3acb",
  null
  
)

export default component.exports